import { Button } from "@progress/kendo-react-buttons";
import "./cell.css";
import { useState } from "react";
import CustomModal from "../../commons/modals/CustomModal";
import { GridCellProps } from "@progress/kendo-react-grid";
import DataForm from "../DataForm";
import showConfirmationModal from "../../commons/helpers/ConfirmationModal";
import { setFormModified } from "../../redux/slices/appStateSlice";
import { useAppSelector } from "../../redux/store";
import { useDispatch } from "react-redux";

interface ActionsCellProps {
    defaultProps: GridCellProps;
    updateData: (result: any) => void;
    deleteData: (prod_num: number) => void;
}

export default function ActionsCell(props: ActionsCellProps) {
    const { defaultProps, updateData, deleteData } = props;
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [formKey, setFormKey] = useState<number>(0);
    const formModified = useAppSelector(state => state.appState.formModified);
    const d_inv010 = useAppSelector(state => state.appState.d_inv010);
    const dispatch = useDispatch();

    const handleOnClose = () => {
        if (formModified === 0 || showConfirmationModal()) {
            dispatch(setFormModified(0));
            setOpenModal(false);
        }
    };

    return <>
        <td>
            <Button icon="edit" className="blueButton round-button" onClick={() => setOpenModal(true)} disabled={!d_inv010.canModify}/>
        </td>
        {openModal && (<CustomModal title="Modifier le produit" body={
            <DataForm item={defaultProps.dataItem} updateData={updateData} deleteData={deleteData} formKey={formKey}
                setFormKey={setFormKey} idTache={-1} />
        }
            onClose={() => handleOnClose()} width={'80%'} />)}
    </>;
}